import React from "react";
import { Link } from "react-router-dom";
import withRouter from "../../common/withRouter.jsx";
import {
    Panel,
    PanelHeader,
    PanelBody,
} from "../../components/panel/panel.jsx";
import Joi from "joi";
import Form from "../../common/form.jsx";
import countries from "../../common/countries.js";
import {savervs, getrvs, getrvss} from "./../../services/rvss";
import { getProfile } from "../../services/authservice.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

class RVS extends Form {
    constructor(props) {
        super(props);
        
        // Initialize with proper array structure
        const initialData = {
            codeNr: "",
            RVS: "",
	    	country: "",
            tags: "",
            receivingWay: [],
            itemBatch: [],
            COO: [],
        };
        
        this.state = {
            data: initialData,
            errors: {},
            isSubmitting: false,
        };
        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    async populatervs() {
        try {
            const rvsId = this.props.params.id;
            if (rvsId === "new") return;

            const { data: rvs } = await getrvs(rvsId);
            const mappedData = this.mapToViewModel(rvs);

            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    ...mappedData,
                    // Ensure arrays are maintained
                    receivingWay: Array.isArray(mappedData.receivingWay) ? mappedData.receivingWay : [],
                    itemBatch: Array.isArray(mappedData.itemBatch) ? mappedData.itemBatch : [],
                    COO: Array.isArray(mappedData.COO) ? mappedData.COO : []
                }
            }));
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                this.props.navigate("/error");
        }
    }
    
    async componentDidMount() {
        try {
            // Check authentication first
            const user = await getProfile();
            if (!user) {
                toast.error("Please log in to access this page.");
                this.props.navigate("/login");
                return;
            }

            await this.populatervs();
            
            const ddata = await getrvss();

            // Update the state with userNo and ensure arrays are maintained
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    userNo: user._id,
                    // Ensure arrays are maintained (fallback to empty arrays if needed)
                    receivingWay: Array.isArray(prevState.data.receivingWay) ? prevState.data.receivingWay : [],
                    itemBatch: Array.isArray(prevState.data.itemBatch) ? prevState.data.itemBatch : [],
                    COO: Array.isArray(prevState.data.COO) ? prevState.data.COO : []
                },
                rvss: ddata.data,
            }));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                toast.error("Please log in to access this page.");
                this.props.navigate("/login");
            } else {
                toast.error("An error occurred while fetching the data.");
            }
        }
    }

    schema = Joi.object({
        codeNr: Joi.string().optional().allow(null, "").label("Code Number"),
        RVS: Joi.string().required().label("RVS Name"),
        country: Joi.string().optional().allow(null, "").label("Country"),
        tags: Joi.string().optional().allow(null, "").label("Tags"),
        receivingWay: Joi.array().items(Joi.string()).optional().label("Receiving Way"),
        itemBatch: Joi.array().items(Joi.string()).optional().label("NBY/FOU/INC"),  
        COO: Joi.array().items(Joi.string()).optional().label("COO Yes/No/Partly"),    
    });

    doSubmit = async () => {
        try {
            const dataToSubmit = { ...this.state.data };
            
            // Remove any undefined or null userNo if not needed
            if (dataToSubmit.userNo === undefined) {
                delete dataToSubmit.userNo;
            }
            
            // Trim whitespace from string fields
            if (dataToSubmit.codeNr) {
                dataToSubmit.codeNr = dataToSubmit.codeNr.trim();
            }
            if (dataToSubmit.RVS) {
                dataToSubmit.RVS = dataToSubmit.RVS.trim();
            }
            if (dataToSubmit.receivingWay && Array.isArray(dataToSubmit.receivingWay)) {
                // Keep as array - server expects arrays
                dataToSubmit.receivingWay = dataToSubmit.receivingWay
                    .map(item => typeof item === 'string' ? item.trim() : item);
            } else if (typeof dataToSubmit.receivingWay === 'string') {
                // Convert string to array if needed
                dataToSubmit.receivingWay = [dataToSubmit.receivingWay.trim()];
            }
			if (dataToSubmit.itemBatch && Array.isArray(dataToSubmit.itemBatch)) {
                // Keep as array - server expects arrays
                dataToSubmit.itemBatch = dataToSubmit.itemBatch
                    .map(item => typeof item === 'string' ? item.trim() : item);
            } else if (typeof dataToSubmit.itemBatch === 'string') {
                // Convert string to array if needed
                dataToSubmit.itemBatch = [dataToSubmit.itemBatch.trim()];
            }
			if (dataToSubmit.COO && Array.isArray(dataToSubmit.COO)) {
                // Keep as array - server expects arrays
                dataToSubmit.COO = dataToSubmit.COO
                    .map(item => typeof item === 'string' ? item.trim() : item);
            } else if (typeof dataToSubmit.COO === 'string') {
                // Convert string to array if needed
                dataToSubmit.COO = [dataToSubmit.COO.trim()];
            }
            
            // Show loading state
            this.setState({ isSubmitting: true });
            
            const response = await savervs(dataToSubmit, this.state.selectedFile);
            
            // Show success message
            toast.success("RVS saved successfully!");
            
            // Small delay to show the success message
            setTimeout(() => {
                // Navigate back to list
                this.props.navigate("/ERP/rvss");
            }, 1000);
            
        } catch (ex) {
            // Reset submitting state
            this.setState({ isSubmitting: false });
            
            if (ex.response) {
                const errors = { ...this.state.errors };
                
                if (ex.response.status === 400) {
                    // Handle validation errors from server
                    if (ex.response.data && typeof ex.response.data === 'object') {
                        if (ex.response.data.message) {
                            toast.error("Validation Error: " + ex.response.data.message);
                        } else if (ex.response.data.error) {
                            toast.error("Error: " + ex.response.data.error);
                        } else {
                            toast.error("Validation error occurred. Please check your input.");
                        }
                    } else if (typeof ex.response.data === "string") {
                        const path = ex.response.data.split('"')[1];
                        if (path) {
                            errors[path] = ex.response.data;
                        } else {
                            toast.error("Error: " + ex.response.data);
                        }
                    } else {
                        toast.error("Bad request. Please check your input data.");
                    }
                } else if (ex.response.status === 409) {
                    toast.error("Conflict: This record may already exist.");
                } else if (ex.response.status === 500) {
                    toast.error("Server error occurred. Please try again later.");
                } else {
                    toast.error(`Error ${ex.response.status}: ${ex.response.data?.message || 'Unknown error'}`);
                }
                
                this.setState({ errors });
            } else if (ex.request) {
                toast.error("Network error: Could not connect to server.");
            } else {
                toast.error("An unexpected error occurred while saving.");
            }
        }
    };
    
    mapToViewModel(rvs) {
        return {
            _id: rvs._id,
            codeNr: rvs.codeNr || "",
            RVS: rvs.RVS || "",
			country: rvs.country || "",
		 	tags: rvs.tags || "",
            receivingWay: rvs.receivingWay ? 
                (typeof rvs.receivingWay === 'string' ? 
                    rvs.receivingWay.split(', ').filter(item => item.trim() !== '') : 
                    (Array.isArray(rvs.receivingWay) ? rvs.receivingWay : [])
                ) : [],
            itemBatch: rvs.itemBatch ? 
                (typeof rvs.itemBatch === 'string' ? 
                    rvs.itemBatch.split(', ').filter(item => item.trim() !== '') : 
                    (Array.isArray(rvs.itemBatch) ? rvs.itemBatch : [])
                ) : [],
            COO: rvs.COO ? 
                (typeof rvs.COO === 'string' ? 
                    rvs.COO.split(', ').filter(item => item.trim() !== '') : 
                    (Array.isArray(rvs.COO) ? rvs.COO : [])
                ) : [],	
        };
    }

    handleMultiSelectChange = (selectedOptions, fieldName) => {
        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
        
        const data = { ...this.state.data };
        data[fieldName] = values;
        
        this.setState({ data });
        
        // Clear any existing errors for this field
        if (this.state.errors[fieldName]) {
            const errors = { ...this.state.errors };
            delete errors[fieldName];
            this.setState({ errors });
        }
    };

    validate = () => {
        const { data } = this.state;
        
        // Create a safe copy with guaranteed arrays
        const dataForValidation = {
            ...data,
            receivingWay: Array.isArray(data.receivingWay) ? data.receivingWay : [],
            itemBatch: Array.isArray(data.itemBatch) ? data.itemBatch : [],
            COO: Array.isArray(data.COO) ? data.COO : []
        };
        
        // Only validate if we have some data or if RVS field has content
        // This prevents showing errors on initial load
        if (!dataForValidation.RVS && 
            dataForValidation.receivingWay.length === 0 && 
            dataForValidation.itemBatch.length === 0 && 
            dataForValidation.COO.length === 0) {
            return { RVS: '"RVS Name" is required' };
        }
        
        const options = { abortEarly: false, allowUnknown: true };
        const { error } = this.schema.validate(dataForValidation, options);
        
        if (!error) return null;
        
        const errors = {};
        for (let item of error.details) {
            errors[item.path[0]] = item.message;
        }
        
        return errors;
    };
    render() {
        const { data, errors } = this.state;
        
        // Ensure all array fields are properly initialized
        const safeData = {
            ...data,
            receivingWay: Array.isArray(data.receivingWay) ? data.receivingWay : [],
            itemBatch: Array.isArray(data.itemBatch) ? data.itemBatch : [],
            COO: Array.isArray(data.COO) ? data.COO : []
        };
        
        const receivingWayOptions = [
            { value: "ZZETES00-1-1-2", label: "ZZETES00-1-1-2" },
            { value: "ZZETES00-1-1-3", label: "ZZETES00-1-1-3" },
            { value: "ZZETES00-1-1-6", label: "ZZETES00-1-1-6" },
            { value: "ZZETES00-1-1-4", label: "ZZETES00-1-1-4" }
        ];
        
        const itemBatchOptions = [
            { value: "NBY", label: "NBY" },
            { value: "FOU", label: "FOU" },
            { value: "INC", label: "INC" }
        ];
        
        const COOOptions = [
            { value: "YES", label: "YES" },
            { value: "NO", label: "NO" },
            { value: "Partly", label: "Partly" }
        ];

        const customStyles = {
            control: (styles) => ({
                ...styles,
                minHeight: "initial",
            }),
            option: (provided) => ({
                ...provided,
            }),
            valueContainer: (base) => ({
                ...base,
                padding: "0 8px",
            }),
            clearIndicator: (base) => ({
                ...base,
                padding: `${(34 - 20 - 1 - 1) / 2}px`,
            }),
            dropdownIndicator: (base) => ({
                ...base,
                padding: `${(34 - 20 - 1 - 1) / 2}px`,
            }),
        };

        return (
            <React.Fragment>
                <ToastContainer />
                <div>
                    <ol className="breadcrumb float-xl-right">
                        <li className="breadcrumb-item">
                            <Link to="/ERP/rvss">RVSs</Link>
                        </li>
                    </ol>
                    <h1 className="page-header">
                        Add RVS <small>RVS Registration Form</small>
                    </h1>

                    <div className="row">
                        <div className="col-xl-10">
                            <Panel>
                                <PanelHeader>Add RVS</PanelHeader>
                                <PanelBody className="panel-form">
                                    <form
                                        className="form-horizontal form-bordered"
                                        onSubmit={this.handleSubmit}
                                    >
                                        {this.renderInput("codeNr", "Code Number", "text", "Enter code number")}
                                        {this.renderInput("RVS", "RVS Name", "text", "Enter RVS name")}                        
                                        {this.renderInput("Tags", "Tags", "text", "Enter tags")}
										<div className="form-group row">
                                            <label className="col-lg-4 col-form-label">
                                                Item-batch
                                            </label>
                                            <div className="col-lg-8">
                                                <Select
                                                    styles={customStyles}
                                                    options={itemBatchOptions}
                                                    placeholder="Select Item-batch(s)..."
                                                    isMulti
                                                    value={itemBatchOptions.filter(option => 
                                                        safeData.itemBatch.includes(option.value)
                                                    )}
                                                    onChange={(selectedOptions) => 
                                                        this.handleMultiSelectChange(selectedOptions, 'itemBatch')
                                                    }
                                                />
                                                {errors.itemBatch && (
                                                    <div className="alert alert-danger">
                                                        {errors.itemBatch}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className="form-group row">
                                            <label className="col-lg-4 col-form-label">
                                                Receiving-Way
                                            </label>
                                            <div className="col-lg-8">
                                                <Select
                                                    styles={customStyles}
                                                    options={receivingWayOptions}
                                                    placeholder="Select Receiving-Way(s)..."
                                                    isMulti
                                                    value={receivingWayOptions.filter(option => 
                                                        safeData.receivingWay.includes(option.value)
                                                    )}
                                                    onChange={(selectedOptions) => 
                                                        this.handleMultiSelectChange(selectedOptions, 'receivingWay')
                                                    }
                                                />
                                                {errors.receivingWay && (
                                                    <div className="alert alert-danger">
                                                        {errors.receivingWay}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className="form-group row">
                                            <label className="col-lg-4 col-form-label">
                                                Country of Origin Checking
                                            </label>
                                            <div className="col-lg-8">
                                                <Select
                                                    styles={customStyles}
                                                    options={COOOptions}
                                                    placeholder="Select CoO checking..."
                                                    isMulti
                                                    value={COOOptions.filter(option => 
                                                        safeData.COO.includes(option.value)
                                                    )}
                                                    onChange={(selectedOptions) => 
                                                        this.handleMultiSelectChange(selectedOptions, 'COO')
                                                    }
                                                />
                                                {errors.COO && (
                                                    <div className="alert alert-danger">
                                                        {errors.COO}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
    
                                        <div className="form-group row">
                                            <div className="col-lg-8">
                                                <button
                                                    type="submit"
                                                    disabled={!!this.validate() || this.state.isSubmitting}
                                                    className="btn btn-primary width-65"
                                                >
                                                    {this.state.isSubmitting ? 'Submitting...' : 'Submit'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </PanelBody>
                            </Panel>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(RVS);
